import { ButtonHTMLAttributes } from 'react';
import styled from 'styled-components';

import { theme } from 'assets/styles/theme';
import { makeTransparentColor } from 'assets/styles/transparentColor';
import plusIcon from 'assets/svg/plus.svg';
import ButtonBase from 'components/buttons/ButtonBase';

const StyledButton = styled(ButtonBase)`
  width: fit-content;
  padding: 0 20px;
  background-color: ${theme.color.white};
  color: ${theme.color.red};
  border: 2px solid ${theme.color.red};

  &:hover {
    box-shadow: 0 0 10px ${makeTransparentColor(theme.color.red, 0.7)};
  }

  ${theme.mq.phone} {
    height: 32px;
    padding: 0 12px;
    font-size: 14px;
    line-height: 16px;
    border-width: 1px;
  }
`;

const ContentContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;

  ${theme.mq.phone} {
    gap: 8px;
  }
`;

const PlusIcon = styled.img`
  width: 18px;
  height: 18px;

  ${theme.mq.phone} {
    width: 14px;
    height: 14px;
  }
`;

export const CreateButton = ({ children, ...otherProps }: ButtonHTMLAttributes<HTMLButtonElement>) => {
  return (
    <StyledButton {...otherProps}>
      <ContentContainer>
        <PlusIcon src={plusIcon} alt={'plus-icon'} />
        {children}
      </ContentContainer>
    </StyledButton>
  );
};
